import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";

import VDatePicker4b from "./VDatePicker4b";
import axios from "axios";
//import "./css/global.css";
import "../index.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Fuse from "fuse.js";
import debounce from "lodash/debounce";
import { useMediaQuery } from "@mui/material";
import BookingSectionAutoCmplSmallScreen from "./BookingSectionAutoCmplSmallScreen";

import { FaTreeCity } from "react-icons/fa6";
import { MdLocationPin } from "react-icons/md";
import { TbRulerMeasure } from "react-icons/tb";
import { merge, orderBy } from "lodash";
import { CiSearch } from "react-icons/ci";

import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";

const formatDate = (date, separator) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}${separator}${month}${separator}${year}`;
};

const MobileAppBookingDateSection = ({
  config = null,
  BookingPageUrl = null,
  citiesDataUrl = "cities.json",
  onChangeConfigUrl = null,
  onChangeDestinationConfigUrl = null,
  dateSeparator = "-",
  monthDisplayType = "month",
  componentName = "home",
  onSearchModify,
}) => {
  console.log("In MobileAppBookingDateSection");

  //const navigate = useNavigate();
  const [cityData, setCityData] = useState([]);
  const [processedCityData, setProcessedCityData] = useState([]);
  const [selectedSource, setSelectedSource] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const [openSource, setOpenSource] = useState(false);
  const [openDestination, setOpenDestination] = useState(false);

  // const [inputSource, setInputSource] = useState(""); // track typed value
  const [inputDestination, setInputDestination] = useState("");

  // this is the reults save
  const [searchSourceResults, setSearchSourceResults] = useState([]);
  const [searchDestinationResults, setSearchDestinationResults] = useState([]);

  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isDestinationOpen, setIsDestinationOpen] = useState(false);

  const [dconfig, setDConfig] = useState(config || null);

  const desRef = useRef();
  const fromDateRef = useRef();
  const toDateRef = useRef();

  const destinationInputRef = useRef();
  const sourceContainerRef = useRef();
  const destinationContainerRef = useRef();

  const isMobile = useMediaQuery("(max-width:600px)");

  const [currentDate, setCurrentDate] = useState();

  const [openOnDestSelect, setOpenOnDestSelect] = useState(false);

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  
  
  const [JourneyType, setJourneyType] = useState("onward");




  const [displayFromDate, setDisplayFromDate] = useState(null);
  const [displayToDate, setDisplayToDate] = useState(null);



  const [selectedChipIndex, setSelectedChipIndex] = useState(0);



 useEffect(() => {
  console.log("Selected Source:", openSource);
 },[openSource]);






  // start of operations


  // fetch city data
  function fetchCityData() {
   // console.log(citiesDataUrl);

    axios
      .get(citiesDataUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        //console.log(res);
        if (res.data) {
          //console.log(res.data);
        }
        const cd = JSON.parse(res.data.ResponseData);
       // console.log(cd);
        setCityData(cd);
        // //console.log(cd.cityList);
        // setSearchSourceResults(cd);
        // setSearchDestinationResults(cd);
      })
      .catch((err) => {
        console.log(err);
      });
  }

    useEffect(()=>{
      // console.log(processedCityData);
       setSearchSourceResults(processedCityData);
       setSearchDestinationResults(processedCityData);
  },[processedCityData]);

  useEffect(()=>{
     // console.log(searchSourceResults);
  },[searchSourceResults]);

  // Fuse instance
  const fuse = useMemo(() => {
    return new Fuse(processedCityData, {
      keys: ["CityName"],
      threshold: 0.2,
      distance: 3,
      minMatchCharLength: 2,
      ignoreLocation: true,
    });
  }, [processedCityData]);

  useEffect(() => {
    fetchCityData();
  }, [citiesDataUrl]);

  // useEffect(() => {
  //   const cdate = formatDate(new Date(), dateSeparator);
  //   setSelectedFromDate(cdate);
  //   const parts = cdate.split(/\D+/);
  //   //console.log(parts);
  //   var day = parseInt(parts[0]);
  //   var month = parseInt(parts[1]);
  //   var year = parseInt(parts[2]);
  //   if (monthDisplayType == "number") {
  //     const cur_date3 = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
  //     setCurrentDate(cur_date3);
  //     setDisplayFromDate(cur_date3); 
  //     setDisplayToDate(cur_date3);
  //   } else {
  //     var dateObject = new Date(year, month - 1, day);
  //    // console.log(dateObject);
  //     const options = { month: "short" };
  //     const monthName = new Intl.DateTimeFormat("en-US", options).format(
  //       dateObject
  //     );
  //     const cur_date = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
  //     setCurrentDate(cur_date);
  //     setDisplayFromDate(cur_date);
  //     setDisplayToDate(cur_date);
  //   }

    
  // }, []);





  useEffect(() => {
  const today = new Date();
  
  // Create a new date object for tomorrow
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  // 1. Handle Selected From Date (Tomorrow)
  const cdateTomorrow = formatDate(tomorrow, dateSeparator);
  

  // 2. Parse tomorrow's date parts
  const parts = cdateTomorrow.split(/\D+/);
  const day = parseInt(parts[0]);
  const month = parseInt(parts[1]);
  const year = parseInt(parts[2]);

  // 3. Parse today's date parts for CurrentDate
  const cdateToday = formatDate(today, dateSeparator);
  const todayParts = cdateToday.split(/\D+/);
  const tDay = parseInt(todayParts[0]);
  const tMonth = parseInt(todayParts[1]);
  const tYear = parseInt(todayParts[2]);
  setSelectedFromDate(cdateToday);

  if (monthDisplayType == "number") {
    const tomorrowStr = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
    const todayStr = `${tDay}${dateSeparator}${tMonth}${dateSeparator}${tYear}`;
    
    setCurrentDate(todayStr); 
    // Keeps today's date
    setDisplayFromDate(todayStr); // Sets tomorrow's date
    setDisplayToDate(tomorrowStr);
  } else {
    // Format Month Names
    const options = { month: "short" };
    
    const tomorrowObj = new Date(year, month - 1, day);
    const mNameTomorrow = new Intl.DateTimeFormat("en-US", options).format(tomorrowObj);
    const tomorrowStr = `${day}${dateSeparator}${mNameTomorrow}${dateSeparator}${year}`;

    const todayObj = new Date(tYear, tMonth - 1, tDay);
    const mNameToday = new Intl.DateTimeFormat("en-US", options).format(todayObj);
    const todayStr = `${tDay}${dateSeparator}${mNameToday}${dateSeparator}${tYear}`;

    setCurrentDate(todayStr); // Keeps today's date
    
    setDisplayFromDate(todayStr); // Sets tomorrow's date
    setDisplayToDate(todayStr);
  }
}, [monthDisplayType, dateSeparator]);

  useEffect(() => {
    if (onChangeConfigUrl) {
      axios
        .get(onChangeConfigUrl, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
         // console.log(res);
          const cd = JSON.parse(res.data.d.data);
          setDConfig(cd);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [onChangeConfigUrl]);


  const getNext7Days = () => {
  const days = [];
  const today = new Date();

  for (let i = 0; i < 7; i++) {
    const d = new Date();
    d.setDate(today.getDate() + i);

    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();

    let display;
    if (monthDisplayType == "number") {
      display = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
    } else {
      const options = { month: "short" };
      const monthName = new Intl.DateTimeFormat("en-US", options).format(d);
      display = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
    }

    let label;
    if (i === 0) label = "Today";
    else if (i === 1) label = "Tomorrow";
    else label = new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(d);

    const chipDate = `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;

    days.push({ label, sub: `${day} ${new Intl.DateTimeFormat("en-US", { month: "short" }).format(d)}`, display, chipDate });
  }

  return days;
};

const dateChips = getNext7Days();


 const onClickOneway = () =>{
  setJourneyType("onward");
  setSelectedChipIndex(0);
  if(selectedChipIndex > 0){

    setDisplayFromDate(dateChips[0]?.chipDate); // Reset displayFromDate to current date when switching to one-way
    setSelectedFromDate(dateChips[0]?.chipDate);

  }
  
  setSelectedToDate(null);
  setDisplayToDate(dateChips[0]?.chipDate); // Reset displayToDate to current date when switching to one-way
 }


 const onClickRoundTrip = () =>{
    setJourneyType("return");
    setSelectedChipIndex(0);
    if(selectedChipIndex > 0){

       setDisplayFromDate(dateChips[0]?.chipDate);
       setSelectedFromDate(dateChips[0]?.chipDate);

       setSelectedToDate(dateChips[0]?.chipDate);
       setDisplayToDate(dateChips[0]?.chipDate);

    }
    
    
 }




//   const groupedCities = useMemo(() => {
//   const map = new Map();

//   cityData.forEach(c => {
//     if (!map.has(c.CityID)) {
//       map.set(c.CityID, {
//         CityID: c.CityID,
//         CityName: c.CityName,
//         ParentCityName: c.ParentCityName || c.CityName,
//         city: c,
//         boardingPoints: []
//       });
//     }

//     if (c.BoardingPointID !== 0) {
//       map.get(c.CityID).boardingPoints.push({
//         ...c,
//         isBoardingPoint: true
//       });
//     }
//   });

//   return Array.from(map.values());
// }, [cityData]);




  const groupedCities = useMemo(() => {
  const map = new Map();
 

  cityData.forEach(c => {
   
       const entry = {
        CityID: c.CityID,
        CityName: c.BoardingPointID === 0 ? c.CityName : c.BoardingPointName.includes(c.CityName) ? c.BoardingPointName : c.BoardingPointName + `, ${c.CityName}`,
        isBoardingPoint: c.BoardingPointID !== 0,
        BoardingPointID: c.BoardingPointID,
        ParentCityName: c.ParentCityName || c.CityName,
        IsPopularDestination: c.IsPopularDestination, 
      };

       
       if (!map.has(c.CityID)) {
        map.set(c.CityID, [entry]);
      } else {
        map.get(c.CityID).push(entry);
      }
    

    
  });

   const groupedData = Array.from(map.values());
   setProcessedCityData(groupedData.flat());
  
}, [cityData]);

//console.log(groupedCities.flat());

// const customSearch = useCallback(
//   (query) => {
//     console.log(groupedCities);
//      if (!query || query.trim() === "") {
     
//       return searchSourceResults;
//     }

//     const lower = query.toLowerCase();

//     // First fuzzy match parent cities
//     const mainMatches = fuse.search(query).map(r => r.item);

//     // if (mainMatches.length === 0) {
//     //   return []; // return empty array instead of previous results
//     // }

//     // Convert Fuse results into GROUPED results
//     const result = [];
   
//     // mainMatches.map(city => {
//     //   const group = groupedCities.find(g => g.CityID === city.CityID);
//     //   if (group) result.push(group);
//     // });

//     // const result = mainMatches
//     //   .map(r => groupedCities.find(g => g.CityID === r.item.CityID))
//     //   .filter(Boolean);

//     mainMatches.forEach(city => {
//       const group = groupedCities.find(g => g.CityID === city.CityID);
//       if (group) result.push(group);
//     });

//     return result;
//   },
//   [groupedCities, fuse]
// );





  const customSearch = useCallback(
    (query) => {
      if (!query) return processedCityData;

      const lowerQuery = query.toLowerCase();

      if (/^[a-z]$/i.test(query)) {
        return processedCityData?.filter((c) =>
          c.CityName.toLowerCase().startsWith(lowerQuery)
        );
      }

       const fuseResults = fuse.search(query).map((r) => r.item);

      if (fuseResults.length === 0) return []; 

      //  const grouped = Object.values(
      //   fuseResults.reduce((acc, city) => {
      //     if (!acc[city.CityID]) {
      //       acc[city.CityID] = [];
      //     }
      //     acc[city.CityID].push(city);
      //     return acc;
      //   }, {})
      // );

  

    
     return fuseResults;

    },
    [processedCityData, fuse]
  );

  // Debounced search updates searchResults state
const debouncedSourceSearch = useMemo(
  () =>
    debounce((query) => {
      const clean = customSearch(query);
     // console.log(clean);
      setSearchSourceResults(clean);  
    }, 300),
  [customSearch]
);


  // Debounced search updates searchResults state
  const debouncedDestinationSearch = useMemo(
    () =>
      debounce((query) => {
        let res = customSearch(query);
       // console.log(res);
        setSearchDestinationResults(customSearch(query));
      }, 500),
    [customSearch]
  );

  // filterOptions for Autocomplete
  const filterSourceOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedSourceSearch(inputValue);
    return searchSourceResults;
  };

  // filterOptions for Autocomplete
  const filterDestinationOptions = (options, { inputValue }) => {
    if (!inputValue) return options;
    debouncedDestinationSearch(inputValue);
    return searchDestinationResults;
  };

  const handleOnSelectOpen = () => {
    // destinationInputRef.current?.focus();
    // const event = new KeyboardEvent("keydown", { key: "tab", bubbles: true });
    // destinationInputRef.current?.dispatchEvent(event);
  };

  const handleOutsideClick = useCallback((event) => {
    const scontainer = sourceContainerRef.current;
    const dcontainer = destinationContainerRef?.current;

  //  console.log(event.target);

    // console.log(scontainer.contains(event.target));
    // console.log(dcontainer.contains(event.target));

    if (
      scontainer &&
      !scontainer.contains(event.target) &&
      dcontainer &&
      !dcontainer.contains(event.target)
    ) {
      if (event.target.closest(".autocomplete-item")) {
       // console.log("ya");
      } else {
        // console.log("no");
        setIsSourceOpen(false);
        setIsDestinationOpen(false);
      }

      // console.log(event.target.classList);
      // if(event.target.classList.contains('autocomplete-item')){
      //     console.log('ya');
      // }else{
      //   setIsSourceOpen(false);
      //   setIsDestinationOpen(false);
      // }

      // setIsSourceOpen(false);
      // setIsDestinationOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);

  const handleSwap = () => {
   // console.log(selectedSource);
    // console.log(selectedDestination);
    if (selectedSource != null && selectedDestination != null) {
      setSelectedSource(selectedDestination);
      setSelectedDestination(selectedSource);
    }
    // setSelectedSource(selectedDestination);
    // setSelectedDestination(selectedSource);
  };

  const handleOnSearchClick = () => {
    sendEventTobackend("SearchButtonClicked",null,1);

    console.log(selectedFromDate);
    console.log(selectedToDate);



    if(selectedToDate != null ){
      if(selectedFromDate == null || selectedFromDate == ''){
        alert('Please select Valid Journey date');
        return;
      }else{
        // console.log(selectedFromDate);
        // console.log(selectedToDate);
        const frmdt = selectedFromDate.split(/[-/]/).reverse().join("-"); 
        const todt = selectedToDate.split(/[-/]/).reverse().join("-");

         console.log(frmdt);
        const date1 = new Date(frmdt);
        const date2 = new Date(todt);

        console.log(date1);
        console.log(date2);

        if (date1 > date2) {
          alert("Invalid journey date.");
          return;
        }
      }

    }else{
      console.log();
    }

    
    console.log("Search Clicked");
    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

      console.log(payload);

      const urldata = new URLSearchParams(payload);
      const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;
      const bookingUrl = `${BookingPageUrl}/${tripslug}?${urldata.toString()}`;

     
      
      if (window.ReactNativeWebView) {
      
         console.log("Sending data to React Native WebView");
        const dataToSend = {
          messageType:"operation",
          action: "searchBuses",
          searchUrl: bookingUrl,
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(dataToSend));
      }else{
        console.log("React Native WebView not available");
      } 


      //console.log(urldata.toString());

      // const tripslug = `${selectedSource.CityName}-to-${selectedDestination.CityName}`;

      // window.location.href = `${BookingPageUrl}/${tripslug}?${urldata.toString()}`;
    }else{
      alert("Please select valid source, destination and journey date.");
    }
  };

  const handleModifySearch = () => {
    sendEventTobackend("ModifyButtonClicked",null,1);
    if (
      selectedSource != null &&
      selectedDestination != null &&
      selectedFromDate != null
    ) {
      // console.log(selectedSource);
      // console.log(selectedDestination);
      // console.log(fromDateRef.current.innerHTML);
      // console.log(toDateRef.current.innerHTML);

      const payload = {
        source: JSON.stringify(selectedSource),
        destination: JSON.stringify(selectedDestination),
        fromDate: selectedFromDate,
        toDate: selectedToDate,
      };

    //  console.log(payload);

      onSearchModify(payload);

      // const urldata = new URLSearchParams(payload);
      // console.log(urldata.toString());

      // const tripslug = `${selectedSource.CM_CityName}-to-${selectedDestination.CM_CityName}`;

      //  window.location.href = `${BookingPageUrl}/${tripslug}?${urldata.toString()}`;
    }
  };


  // end of operations 

  return (
    <>
      <div className="mobile-app-bookingdate-container">
        <div className="mobile-app-bookingdate-section">
          <div className="mobile-app-trip-button-container">
             <div className="mobile-app-trip-button-inner-container">
                  <div className={`mobile-app-trip-button  ${JourneyType == 'onward' && 'mobile-app-trip-button-active' } `} onClick={onClickOneway} >One Way</div>
                  <div className={`mobile-app-trip-button ${JourneyType == 'return' && 'mobile-app-trip-button-active' } `}    onClick={onClickRoundTrip}>
                        Round Trip
                </div>
             </div>
          </div>

          <div className="mobile-app-source-destination-container">
            <div className="mobile-app-input-section">
              <div className="mobile-app-source-input" onClick={() => {setOpenSource(true);
                                        console.log("It clicked")  
                                        sendEventTobackend("SourceClicked",null,1); 
                                      }} >
                <span>From.</span>
                <div >
                  <TextField
                    value={selectedSource?.CityName || ""}
                    placeholder="Select From City"
                    fullWidth
                    size="small"
                    
                    sx={{
                      pointerEvents: "none",
                      ".MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      ".MuiInput-underline:after": {
                        borderBottom: "none",
                      },
                      ".MuiInput-underline:before": {
                        borderBottom: "none",
                      },
                      ".MuiFilledInput-underline:after": {
                        borderBottom: "none",
                      },
                      ".MuiFilledInput-underline:before": {
                        borderBottom: "none",
                      },

                      // 1. Style for the SELECTED VALUE text
                      "& .MuiInputBase-input": {
                        color: "#1f1f1f",
                        fontSize: "16px",
                        fontWeight: "600", // Makes the selected text bold
                      },

                      // 2. Style for the PLACEHOLDER text
                      "& .MuiInputBase-input::placeholder": {
                        color: "#1f1f1f",
                        fontSize: "16px", 
                        fontWeight: "600",
                        opacity: 1, 
                      },


                      ".autocomplete-input2": {
                        // color: "#1f1f1f",
                        // fontWeight: "bold",
                        // paddingLeft: "20px",
                      },
                    }}
                    InputProps={{
                      readOnly: true, // Make the input field read-only
                    }}
                  />
                </div>
              </div>

              <div className="mobile-app-swap-icon"
              
                onClick={() => handleSwap()}
              
              ></div>

              <div className="mobile-app-source-input">
                <span>To</span>
                <div onClick={() =>{setOpenDestination(true);sendEventTobackend("DestinationClicked",null,1); }}>
                  <TextField
                    value={selectedDestination?.CityName || ""}
                    placeholder="Select To City"
                    fullWidth 
                    size="small"
                    
                    sx={{
                      ".MuiOutlinedInput-notchedOutline": {
                        border: "none",
                      },
                      ".MuiInput-underline:after": {
                        borderBottom: "none",
                      },
                      ".MuiInput-underline:before": {
                        borderBottom: "none",
                      },
                      ".MuiFilledInput-underline:after": {
                        borderBottom: "none",
                      },
                      ".MuiFilledInput-underline:before": {
                        borderBottom: "none",
                      },

                      // 1. Style for the SELECTED VALUE text
                      "& .MuiInputBase-input": {
                        color: "#1f1f1f",
                        fontSize: "16px",
                        fontWeight: "600", // Makes the selected text bold
                      },

                      // 2. Style for the PLACEHOLDER text
                      "& .MuiInputBase-input::placeholder": {
                        color: "#1f1f1f",
                        fontSize: "16px", 
                        fontWeight: "600",
                        opacity: 1, 
                      },

                      ".autocomplete-input2": {
                        color: "#1f1f1f",
                        fontWeight: "bold",
                        paddingLeft: "20px",
                        fontSize: "16px",
                      },
                    }}
                    InputProps={{
                      readOnly: true, // Make the input field read-only
                    }}
                  />
                </div>
              </div>


                    



            </div>
            <div className="mobile-app-datepicker-container">

             <div className="mobile-app-datepickers-input">
                <span>Departure</span>
                <div className="mobile-app-datepickers">
                  {/* <input
                    type="text"
                    ref={fromDateRef}
                    id="from-date"
                    placeholder="11-09-2025"
                  /> */}
                  <div className="input-element" ref={fromDateRef}>
                    {" "}
                    
                    <span style={{ color: "#1f1f1f", fontWeight: "600", fontSize: "16px" }}> {displayFromDate} </span>
                  </div>

                  <VDatePicker4b
                    targetRef={fromDateRef}
                    onDateSelect={(date) => {
                      console.log(date);
                      setSelectedFromDate(date);
                      //fromDateRef.current.innerHTML = date;
                       sendEventTobackend("OnwardDateSelected",null,1);
                      //console.log(date);
                      const parts = date.split(/\D+/);
                     // console.log(parts);
                      var day = parseInt(parts[0]);
                      var month = parseInt(parts[1]);
                      var year = parseInt(parts[2]);
                      if (monthDisplayType == "number") {
                        //fromDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                        setDisplayFromDate(`${day}${dateSeparator}${month}${dateSeparator}${year}`);
                      } else {
                        var dateObject = new Date(year, month - 1, day);
                        //console.log(dateObject);
                        const options = { month: "short" };
                        const monthName = new Intl.DateTimeFormat(
                          "en-US",
                          options
                        ).format(dateObject);
                        //fromDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                        setDisplayFromDate(`${day}${dateSeparator}${monthName}${dateSeparator}${year}`);
                      }

                      setSelectedChipIndex(null); // Deselect any selected chip when a date is manually selected
                    }}
                    minDate={"10/01/2024"}
                    configFromApi={dconfig ? dconfig : null}
                    type="text"
                    openOnClose={openOnDestSelect}
                  />

               
                
                </div>
              </div>

              { JourneyType == 'return' &&
                <>
                   <div className="mobile-app-datepickers-input">
                <span>Return</span>
                <div className="mobile-app-datepickers">
                  {/* <input
                    type="text"
                    ref={fromDateRef}
                    id="from-date"
                    placeholder="11-09-2025"
                  /> */}

                  <div  style={{display: "flex", alignItems: "center",justifyContent: "space-between", width: "100%"}}>

                    <div style={{display:"flex",width:"90%"}} ref={toDateRef}>
                      
                       <div className="input-element" >
                                        
                        <span style={{ color: "#1f1f1f", fontWeight: "600", fontSize: "16px" }}> {displayToDate} </span>
                       </div>

                    </div>
                     

                    {selectedToDate && (
                      <button
                        type="button"
                        className="return-date-clear-btn"
                        aria-label="Clear return date"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onTouchStart={(e) => {
                          e.stopPropagation();
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedToDate(null);
                          setDisplayToDate(null);

                          onClickOneway();

                          

                          // setJourneyType("return");
                          // setSelectedChipIndex(0);
                          // setDisplayFromDate(dateChips[0]?.chipDate);
                          // setSelectedFromDate(dateChips[0]?.chipDate);
                          // setSelectedToDate(dateChips[0]?.chipDate);
                          // setDisplayToDate(dateChips[0]?.chipDate);


                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          minWidth: "20px",
                          padding: 0,
                          margin: "0 8px",
                          border: "none",
                          borderRadius: "50%",
                          backgroundColor: "rgba(0, 0, 0, 0.08)",
                          color: "#1f1f1f",
                          fontSize: "13px",
                          lineHeight: "1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          flexShrink: 0,
                        }}
                      >
                        ×
                      </button>
                    )}

                  </div>
                  

                  <VDatePicker4b
                    targetRef={toDateRef}
                    onDateSelect={(date) => {
                      console.log(date);
                      setSelectedToDate(date);
                      //fromDateRef.current.innerHTML = date;
                       sendEventTobackend("ReturnDateSelected",null,1);
                      //console.log(date);
                      const parts = date.split(/\D+/);
                     // console.log(parts);
                      var day = parseInt(parts[0]);
                      var month = parseInt(parts[1]);
                      var year = parseInt(parts[2]);
                      if (monthDisplayType == "number") {
                        //toDateRef.current.innerHTML = `${day}${dateSeparator}${month}${dateSeparator}${year}`;
                        setDisplayToDate(`${day}${dateSeparator}${month}${dateSeparator}${year}`);
                      } else {
                        var dateObject = new Date(year, month - 1, day);
                        //console.log(dateObject);
                        const options = { month: "short" };
                        const monthName = new Intl.DateTimeFormat(
                          "en-US",
                          options
                        ).format(dateObject);
                        //toDateRef.current.innerHTML = `${day}${dateSeparator}${monthName}${dateSeparator}${year}`;
                        setDisplayToDate(`${day}${dateSeparator}${monthName}${dateSeparator}${year}`)
                      }
                    }}
                    minDate={"10/01/2024"}
                    configFromApi={dconfig ? dconfig : null}
                    type="text"
                    openOnClose={openOnDestSelect}
                  />

               
                
                </div>
              </div>
                </>
              }

            </div>        
             
          </div>




              {/*  7 days list  */}


              {   JourneyType == 'onward' &&

                   <div
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      WebkitOverflowScrolling: "touch",
                      gap: "8px",
                      padding: "8px 0",       // removed side padding so edges align with inputs above
                      margin: "0 16px",       // match the horizontal margin/padding of mobile-app-datepicker-container
                      width: "calc(100% - 40px)", // same effective width as the departure/return section
                      boxSizing: "border-box",
                      scrollbarWidth: "none",
                    }}
                 >
                {dateChips.map((chip, index) => {
                  const isSelected = selectedChipIndex === index;
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        // toggle: clicking the already-selected chip deselects it
                        const newIndex = isSelected ? null : index;
                        setSelectedChipIndex(newIndex);

                        if (newIndex !== null) {
                          setSelectedFromDate(chip.chipDate);
                          setDisplayFromDate(chip.display);
                        }
                      }}
                      style={{
                        flex: "0 0 auto",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: "56px",
                        padding: "6px 10px",
                        borderRadius: "16px",
                        border: isSelected ? "1px solid #2D40A9" : "1px solid #e0e0e0",
                        backgroundColor: isSelected ? "#2D40A9" : "#ffffff",
                        color: isSelected ? "#ffffff" : "#1f1f1f",
                        cursor: "pointer",
                        userSelect: "none",
                        transition: "background-color 0.15s ease, border-color 0.15s ease",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {chip.label}
                      </span>
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: 400,
                          marginTop: "2px",
                          whiteSpace: "nowrap",
                          opacity: isSelected ? 0.9 : 0.7,
                        }}
                      >
                        {chip.sub}
                      </span>
                    </div>
                  );
                })}
              </div>


              }



             

              {/* end of 7 days list */}




          <div className="mobile-app-searchbutton-container">
           
                <div className="mobile-app-search-button-mobileapp" onClick={handleOnSearchClick}> Search Buses </div>

          </div>
        </div>
      </div>



                  <BookingSectionAutoCmplSmallScreen
                    open={openSource}
                    onClose={() => setOpenSource(false)}
                    value={selectedSource}
                    setValue={setSelectedSource}
                    cityData={processedCityData}
                    fuse={fuse}
                    label={"Source"}
                  />

                  <BookingSectionAutoCmplSmallScreen
                    open={openDestination}
                    onClose={() => {
                      setOpenDestination(false);
                      if (onChangeDestinationConfigUrl != null) {
                        axios
                          .get(onChangeDestinationConfigUrl, {
                            headers: {
                              "Content-Type": "application/json",
                            },
                          })
                          .then((res) => {
                           // console.log(res);

                            if (res.data) {
                              if (config) {
                                const mconfig = merge({}, config, res.data);

                                //console.log(mconfig);
                                setDConfig(mconfig);
                              } else {
                               // console.log("local data not available");
                              }
                            }
                          })
                          .catch((err) => {
                           // console.log(err);
                          });
                      }
                    }}
                    value={selectedDestination}
                    setValue={setSelectedDestination}
                    cityData={processedCityData}
                    fuse={fuse}
                    label={"Destination"}
                  />
    </>
  );
};

export default MobileAppBookingDateSection;
